import { useSyncExternalStore } from "react";

/**
 * (Task Q) Kiosk DEVICE account on this tablet: the device credential from pairing. (Task DD2) Staff now clock in / out
 * ONLY on their own phone, so a tablet paired earlier just shows an explanation + the normal sign-in, which forgets the
 * credential. Kiosk MODE (the clock screen lock) is gone too; its flag is cleared.
 */
export interface KioskDeviceInfo { token: string; deviceId: string; deviceName: string; branchName: string; tenantName: string; server?: string | null }
const KEY = "spos.kioskDevice";
const MODE = "spos.kioskMode";
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
export const onKioskChange = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };

export function loadKioskDevice(): KioskDeviceInfo | null {
  try { const v = JSON.parse(localStorage.getItem(KEY) ?? "null"); return v && typeof v.token === "string" ? v : null; } catch { return null; }
}
export function saveKioskDevice(v: KioskDeviceInfo | null) {
  try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); } catch { /* private mode */ }
  emit();
}

/** (Task DD2) the old "lock this tablet to the clock screen" flag — only ever cleared now. */
export function setKioskMode(on: boolean) {
  try { if (!on) localStorage.removeItem(MODE); } catch { /* private mode */ }
  emit();
}

export const useKioskDevice = () => useSyncExternalStore(onKioskChange, kioskDeviceRaw, kioskDeviceRaw);
function kioskDeviceRaw(): string | null { try { return localStorage.getItem(KEY); } catch { return null; } }
